import { Controller } from '@hotwired/stimulus';

// Turbo Drive is off app-wide (application.js), so nothing stops a second full POST when someone
// clicks again during a slow submit. On signup that races past the uniqueness validation and dies
// on the unique index instead (UNS-5114).
export default class extends Controller {
  static targets = ['button'];

  connect() {
    this.onPageShow = (event) => this.#unlockIfRestored(event);
    window.addEventListener('pageshow', this.onPageShow);
  }

  disconnect() {
    window.removeEventListener('pageshow', this.onPageShow);
  }

  lock() {
    // bootstrap_validation.js cancels invalid submits, which would strand the button disabled.
    if (!this.element.checkValidity()) return;

    // Deferred: a submit button disabled inside its own submit event drops its name/value from the post.
    setTimeout(() => this.#setDisabled(true), 0);
  }

  #unlockIfRestored(event) {
    if (event.persisted) this.#setDisabled(false);
  }

  #setDisabled(disabled) {
    this.buttonTargets.forEach((button) => {
      button.disabled = disabled;
    });
  }
}
